var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pills',{staticClass:"mb-2",attrs:{"filtro":_vm.filtro}}),_c('VueApexCharts',{attrs:{"width":"450","options":_vm.data.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }